<template>
  <section class="lb-portal">
    <div :style="inLineStyle" class="search-bar-vue">
      <div v-if="showBar || alwaysOpen" id="search" data-test-search-bar class="">
        <div class="container">
          <div class="form-container grid-x">
            <div class="auto cell">
              <input
                data-test-search-bar-input
                type="text"
                :placeholder="inputPlaceholder"
                :value="searchTerm"
                @input="inputChanged"
                @keyup.enter="performSearch"
              />
            </div>
            <div class="column shrink grid-x icon-padding-bottom">
              <button
                :class="{ 'small-6': large, 'small-12': !large }"
                class="button small white cell align-self-middle icon-margin-right"
                data-test-search-bar-search-button
                @click="performSearch"
              >
                <i
                  class="icon-search"
                  data-clickcategory="minside"
                  data-clickaction="click-header"
                  data-clicklabel="Search"
                />
              </button>
              <button
                v-if="large"
                class="button small white column small-6 align-self-middle"
                data-test-search-bar-close
                @click="closeSearch"
              >
                <i class="icon-close" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { SearchBarData } from './types/SearchBar';
import HeaderBaseMixinVue from '../Header/HeaderBaseMixin.vue';
import Utility from '@/common/UtilityFunctions.js';
import { defineComponent } from 'vue';
// import _ from 'lodash';

export default defineComponent({
  name: 'SearchBar',
  mixins: [HeaderBaseMixinVue],
  props: {
    fieldPlaceholderText: {
      type: String,
      default() {
        return 'Søg';
      }
    },
    searchPageUrl: {
      type: String,
      default() {
        return '';
      }
    },
    alwaysOpen: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data(): SearchBarData {
    return {
      inLineStyle: '',
      searchResults: [],
      amountToTake: 20,
      searchTerm: '',
      spinnerUrlList: []
    };
  },
  computed: {
    showBar(): boolean {
      return this.$store.state.search.barShown;
    },
    inputPlaceholder(): string {
      return Utility.decodeHtml(this.fieldPlaceholderText);
    }
  },
  created() {
    // this.getAutoSuggestionsDebounced = _.debounce((inputText: string) => {
    //     if (inputText.length > 2)
    //         this.$store.dispatch('search/searchAutosuggestions', inputText);
    //     else if (inputText === '')
    //         this.$store.dispatch('search/resetAutosuggestions');
    // }, 500);
  },
  methods: {
    closeSearch(): void {
      this.$store.commit('search/toggleBar');
    },
    inputChanged(event: Event): void {
      const target = event.target as HTMLInputElement;
      const inputText = target.value;
      this.searchTerm = inputText;
      // if(this.getAutoSuggestionsDebounced)
      //     this.getAutoSuggestionsDebounced(inputText);
    },
    performSearch(): void {
      let currentLocation = location.pathname;
      const redirectLink = `${this.searchPageUrl}?q=${this.searchTerm}`;

      if (currentLocation !== this.searchPageUrl) window.location.href = redirectLink;
      else window.history.pushState({ path: redirectLink }, '', redirectLink);
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';
.icon-padding-bottom {
  padding-bottom: rem-calc(15px);
}

.icon-margin-right {
  margin-right: rem-calc(15px);
}
</style>
